import { DNSEHead } from 'components/common/DNSEHead';
import { GetStaticProps } from 'next';
import React from 'react';

import {
  Menu,
  NormalizeMenu,
  getRecruitmentMenusHeaderAndFooter
} from '@dnse/services';

import { JobDetails } from '../../components/JobsOpportunities/JobDetails';
import { JobsOpportunitiesBanner } from '../../components/JobsOpportunities/JobsOpportunitiesBanner';
import RecruitmentLayout from '../../layout';
import {
  getAllJobsPaths,
  getAllOpeningJobs,
  getJobBySlug,
  getRecommendSkills,
  getTotalNumberOpeningJobs
} from '../../services/graphql/directus';
import { JobType } from '../../types';
import { AppEnv } from '../../utils/accessEnviroment';

interface PageProps {
  menusHeader: Menu[];
  menusFooter: NormalizeMenu;
  job: JobType;
  totalNumberOpeningJobs: number;
  recommendJobs: JobType[];
  recommendSkills: string[];
}

const JobDetailsPage: React.FC<PageProps> = ({
  menusFooter,
  menusHeader,
  job,
  totalNumberOpeningJobs,
  recommendJobs,
  recommendSkills
}) => {
  return (
    <RecruitmentLayout menusFooter={menusFooter} menusHeader={menusHeader}>
      <DNSEHead
        title={job.title}
        description="Tuyển dụng DNSE - Cơ hội nghề nghiệp cho tương lai"
      />
      <JobsOpportunitiesBanner
        totalNumberOpeningJobs={totalNumberOpeningJobs}
        recommendSkills={recommendSkills}
      />
      <JobDetails job={job} recommendJobs={recommendJobs} />
    </RecruitmentLayout>
  );
};

export default JobDetailsPage;

export const getStaticPaths = async () => {
  if (process.env.NO_ISR === 'true') {
    return {
      paths: [],
      fallback: 'blocking'
    };
  }

  const paths = await getAllJobsPaths();
  return {
    paths,
    fallback: 'blocking'
  };
};

export const getStaticProps: GetStaticProps<PageProps> = async ({ params }) => {
  const slug = params?.slug as string;
  if (!slug) return { notFound: true };

  const [
    menus,
    totalNumberOpeningJobs,
    job,
    getAllOpeningJobsRes,
    recommendSkills
  ] = await Promise.all([
    getRecruitmentMenusHeaderAndFooter(),
    getTotalNumberOpeningJobs(),
    getJobBySlug(slug),
    getAllOpeningJobs(),
    getRecommendSkills()
  ]);

  return {
    props: {
      menusHeader: menus.menusHeader,
      menusFooter: menus.menusFooter,
      job,
      totalNumberOpeningJobs,
      recommendJobs: getAllOpeningJobsRes.jobs,
      recommendSkills
    },
    revalidate: AppEnv.REVALIDATE
  };
};
